import { useMemo } from "react";

export default function useEventStats(angebote, jobs, currentUser) {
  const stats = useMemo(() => {
    const teamSlots = angebote.filter((a) => a.type === "team");
    const leitungSlots = angebote.filter((a) => a.type === "leitung");

    const filledTeam = teamSlots.filter((a) => a.reservedBy).length;
    const filledLeitung = leitungSlots.filter((a) => a.reservedBy).length;

    const totalTeam = teamSlots.length;
    const totalLeitung = leitungSlots.length;

    const totalFilled = filledTeam + filledLeitung;
    const totalSlots = totalTeam + totalLeitung;

    const myJobsCount = angebote.reduce((sum, angebot) => {
      if (angebot.reservedBy?.id !== currentUser.id) return sum;

      const job = jobs.find((j) => j.id === angebot.jobId);
      if (!job) return sum;

      const weight =
        job.title === "Service Schicht 1" || job.title === "Service Schicht 2"
          ? 2
          : 1;

      return sum + weight;
    }, 0);

    const mySlotsCount = angebote.reduce((sum, angebot) => {
      if (!currentUser) return sum;

      if (angebot.reservedBy?.id !== currentUser.id) return sum;

      return sum + 1;
    }, 0);

    const openLeitungTotal = angebote.reduce((sum, a) => {
      if (a.type === "leitung" && !a.reservedBy) {
        return sum + 1;
      }
      return sum;
    }, 0);

    const openSuSTotal = angebote.reduce((sum, a) => {
      if (a.type === "team" && !a.reservedBy) {
        return sum + 1;
      }
      return sum;
    }, 0);

    return {
      teamSlots,
      leitungSlots,
      filledTeam,
      filledLeitung,
      totalTeam,
      totalLeitung,
      totalFilled,
      totalSlots,
      myJobsCount,
      mySlotsCount,
      openLeitungTotal,
      openSuSTotal,
    };
  }, [angebote, currentUser, jobs]);

  return stats;
}
